export const schedule = {
  "Let's schedule?": 'Vamos agendar?',
  Schedule: 'Agendamento',
  'Try again': 'Tentar novamente',
};
